import './refresh-shim'
import ReactDOM, { Container } from 'react-dom/client'
import './index.css'
import { App } from './app'

const darkMode = localStorage.getItem('darkMode')
if (darkMode) {
  document.body.classList.add('dark-mode')
}

const root = ReactDOM.createRoot(document.getElementById('root') as Container)
root.render(<App />)
